/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {IMedicalSpecialty} from '@app/shared/models/medical-specialty.model';
import {Observable, map} from 'rxjs';
import {ICity} from 'src/app/shared/models/city.model';
import {ICountry} from 'src/app/shared/models/country.model';
import {IRegion} from 'src/app/shared/models/region.model';
import {environment} from 'src/environments/environment';
import {IPhysicianSignUpRequest} from '../models/sign-up-request.model';
import {ISignUpResponse} from '../models/sign-up-response.model';

@Injectable({
  providedIn: 'root',
})
export class SignUpService {
  private readonly _httpClient = inject(HttpClient);

  private readonly getAllCountriesUrl = `${environment.api.baseUrl}/${environment.api.config.getCountries}`;
  private readonly getAllRegionsUrl = `${environment.api.baseUrl}/${environment.api.config.getRegions}`;
  private readonly getAllCitiesUrl = `${environment.api.baseUrl}/${environment.api.config.getCities}`;
  private readonly getAllmedicalSpecialitiesUrl = `${environment.api.baseUrl}/${environment.api.config.getAllSpecialities}`;
  private readonly registerUrl = `${environment.api.baseUrl}/${environment.api.customer.register}`;
  private readonly resendNewTokenUrl = `${environment.api.baseUrl}/${environment.api.resendTokenUrl}`;
  private readonly validateRecaptchaUrl = `${environment.api.authUrl}/${environment.api.customer.validateRecaptchaToken}`;

  getCountries(): Observable<ICountry[]> {
    return this._httpClient.get<ICountry[]>(this.getAllCountriesUrl).pipe(
      map(countries => {
        return countries.filter(t => t.enabled);
      })
    );
  }

  getRegions(countryId: number): Observable<IRegion[]> {
    return this._httpClient.get<IRegion[]>(`${this.getAllRegionsUrl}/${countryId}`).pipe(
      map(regions => {
        return regions.filter(t => t.enabled);
      })
    );
  }
  getCities(countryId: number, regionId: number): Observable<ICity[]> {
    return this._httpClient.get<ICity[]>(`${this.getAllCitiesUrl}?countryId=${countryId}&regionId=${regionId}`).pipe(
      map(cities => {
        return cities.filter(t => t.enabled);
      })
    );
  }
  getMedicalSpecialties(): Observable<IMedicalSpecialty[]> {
    return this._httpClient.get<IMedicalSpecialty[]>(this.getAllmedicalSpecialitiesUrl).pipe(
      map(medicalSpecialty => {
        return medicalSpecialty.filter(t => t.enabled);
      })
    );
  }
  signUpRequest(signupRequst: IPhysicianSignUpRequest): Observable<ISignUpResponse> {
    return this._httpClient.post<ISignUpResponse>(this.registerUrl, signupRequst);
  }

  resendLink(email: string): Observable<string> {
    const body = null;

    let params = new HttpParams();
    params = params.append('email', email);

    return this._httpClient.post(this.resendNewTokenUrl, body, {
      params: params,
      responseType: 'text',
    });
  }

  getRecaptchaResponse(token: string): Observable<boolean> {
    return this._httpClient.post<boolean>(this.validateRecaptchaUrl, {token});
  }
}
